__turbopack_context__.v({
  "defaultTransition": "styles-module__jTJ9Xq__defaultTransition",
  "dropdown": "styles-module__jTJ9Xq__dropdown",
  "hamburger": "styles-module__jTJ9Xq__hamburger",
  "hyperlink": "styles-module__jTJ9Xq__hyperlink",
  "navHome": "styles-module__jTJ9Xq__navHome",
  "navLink": "styles-module__jTJ9Xq__navLink",
  "transitionsContainer": "styles-module__jTJ9Xq__transitionsContainer",
});
